<template>
  <div class="widget-selector">
    <h2>Available widgets</h2>
    <p>To activate a widget drag it to a footer column or click on it.</p>
    <div class="header" draggable="true" @drag="isDragging('text')" >
      <i class="material-icons">expand_more</i>
      <span> Text </span>
    </div>
    <div class="header" draggable="true" @drag="isDragging('html')" >
      <i class="material-icons">expand_more</i>
      <span> Custom HTML </span>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    isDragging(type){
      this.$emit('isDragging', type)
    },
  }
};
</script>

<style lang="scss" scoped>
.widget-selector {
  margin: 46px 0;
  h2 {
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    color: #001529;
  }
  p {
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: #001529;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 302px;
    min-height: 46px;
    background: #f4f5f7;
    padding: 18px;
    margin: 25px 0;
    cursor: pointer;
    .material-icons {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    span {
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #001529;
      margin: 0 20px;
    }
  }
}
</style>